// Convex's `cases` table is camelCase (see frontend/convex/schema.ts); the
// rest of the still-Express-backed frontend expects the old snake_case
// `Case` shape from src/types.ts. This adapter is scoped to the cases
// list/detail pages wired to Convex this migration pass — not a general
// API-shape shim for the whole app.
import type { Case } from '../types';

export function fromConvexCase(doc: any): Case {
  return {
    id: doc._id,
    company_id: doc.companyId,
    firm_id: doc.firmId ?? null,
    created_by: doc.createdBy ?? null,
    name: doc.name,
    description: doc.description ?? null,
    case_theory: doc.caseTheory ?? null,
    practice_area: doc.practiceArea ?? null,
    sim_count: doc.simCount ?? 0,
    venue_state: doc.venueState,
    venue_county: doc.venueCounty,
    venue_county_fips: doc.venueCountyFips ?? null,
    venue_personality: doc.venuePersonality,
    status: doc.status ?? 'active',
    client_side: doc.clientSide as Case['client_side'],
    visibility: doc.visibility,
    created_at: new Date(doc._creationTime).toISOString(),
    updated_at: new Date(doc._creationTime).toISOString(),
  };
}
